import request from "../../utils/api";

export const getDataMonitoring = params => {
  const partnerId = params;
  return request(`v1/sellers/data-monitoring/${partnerId}`, {
    params
  });
};
export const getColdLead = params => {
  return request(`v1/sellers/get-cold-lead`, {
    params
  });
};
export const getSchedules = params => {
  const { userID } = params;

  return request(`v1/sellers/schedules/${userID}`, {
    params
  });
};

export const createSchedule = params => {
  const { userID } = params;

  return request(`v1/sellers/schedules/${userID}`, {
    method: "post",
    body: params.body
  });
};

export const updateSchedule = params => {
  const { scheduleId } = params;

  return request(`v1/sellers/schedules/${scheduleId}`, {
    method: "put",
    body: params.body
  });
};

export const markAsDone = params => {
  
  return request(`v1/sellers/schedules/done/${params.id}`, {
    method: "put",
    body: params
  });
};

export const deleteSchedule = params => {
  const { scheduleId } = params;

  return request(`v1/sellers/schedules/${scheduleId}`, {
    method: "delete"
  });
};

export const getProductivity = params => {
  return request("v1/sellers/productivity", {
    params
  });
};

export const getReleasedCommissions = params => {
  return request("v1/sellers/released_commissions", {
    params
  });
};

export const getReceivableCommissions = params => {
  return request("v1/sellers/receivable_commissions", {
    params
  });
};

export const getQualifiedCommissions = params => {
  return request("v1/sellers/qualified_commissions", {
    params
  });
};

export const searchForUser = params => {
  return request("v1/sellers/customer-360/search-lead", {
    method: "post",
    params
  });
};

export const postUserInformation = payload => {
  return request("v1/sellers/e-reservations/user_information", {
    method: "post",
    body: payload
  });
};

export const getUserInformation = payload => {
  return request(
    `v1/sellers/e-reservations/user_information/${payload.rNo}/${payload.type}`,
    {
      payload
    }
  );
};

export const postPurchaseJourney = payload => {
  return request("v1/sellers/e-reservations/survey", {
    method: "post",
    body: payload
  });
};

export const getPurchaseJourney = payload => {
  return request(`v1/sellers/e-reservations/survey/${payload}`, {
    payload
  });
};

export const postCustomerAttachments = payload => {
  return request(`v1/sellers/e-reservations/attachment`, {
    method: "post",
    body: payload
  });
};

export const getAttachments = payload => {
  return request(`v1/sellers/e-reservations/attachment/${payload.rNo}`, {
    payload
  });
};

export const postClientSignature = payload => {
  return request(`v1/sellers/e-reservations/signature`, {
    method: "post",
    body: payload
  });
};

export const getUserInformationFromSap = payload => {
  return request(
    `v1/sellers/e-reservations/user/profile/${payload.buyerId}/${payload.rNo}/${payload.type}`,
    {
      payload
    }
  );
};

export const getClientSignature = payload => {
  return request(`v1/sellers/e-reservations/signature/${payload}`, {
    payload
  });
};

export const getReservationDetails = payload => {
  return request(`v1/sellers/e-reservations/details/${payload}`, {
    payload
  });
};

export const getSapBookingList = payload => {
  return request(`v1/sellers/e-reservations`, {
    payload
  });
};

export const getBookingList = payload => {
  return request(`v1/sellers/customer-360/reservation`, {
    payload
  });
};

export const submitBookingStatus = payload => {
  return request(`v1/sellers/e-reservations/booking_status/${payload.rNo}`, {
    method: "post",
    body: payload.body
  });
};

export const postLeadForm = payload => {
  if (payload.param) {
    // if lead renewal request
    if (payload.type) {
      return request(
        `v1/sellers/customer-360/lead/${payload.param}/${payload.type}`,
        {
          method: "post",
          body: payload.body
        }
      );
    }

    // edit lead state
    return request(`v1/sellers/customer-360/lead/${payload.param}`, {
      method: "post",
      body: payload.body
    });
  }
  return request(`v1/sellers/customer-360/lead`, {
    method: "post",
    body: payload.body
  });
};

export const getBrands = payload => {
  return request(`v1/web/brand`, {
    payload
  });
};

export const getLead = () => {
  return request(`v1/sellers/customer-360/seller/leads`);
};

export const getBuyerHistory = () => {
  return request(`v1/sellers/customer-360/seller/buyer-history`);
};

export const getLeadProfile = payload => {
  return request(`v1/sellers/customer-360/lead/${payload}`, {
    payload
  });
};

export const postObservation = payload => {
  return request(`v1/sellers/customer-360/observation`, {
    method: "post",
    body: payload.body
  });
};

export const getTransferRequest = () => {
  return request(`v1/sellers/customer-360/transfer-request/history`);
};

export const getSellerGroup = () => {
  return request(`v1/user/seller/list`);
};

export const postTransferRequest = payload => {
  return request(`v1/sellers/customer-360/transfer/lead`, {
    method: "post",
    body: payload.body
  });
};

export const getNationalities = () => {
  return request(`v1/sellers/customer-360/nationality`);
};

export const postLeadSignature = payload => {
  return request(`v1/sellers/customer-360/signature`, {
    method: "post",
    body: payload.body
  });
};

export const getLeadBuyer = () => {
  return request(`v1/sellers/customer-360/seller/buyers`);
};

export const getRetention = () => {
  return request(`v1/sellers/customer-360/lead-retention`);
};

export const claimOwnership = params => {
  return request(`v1/sellers/customer-360/lead/claim/ownership/seller`, {
    method: "post",
    body: params.body
  });
};

export const postRequestOwnershipExtension = params => {
  return request(`v1/sellers/customer-360/ownership/extension`, {
    method: "post",
    body: params.body
  });
};

export const postRequestSubmissionExtension = params => {
  return request(`v1/sellers/customer-360/submission/extension`, {
    method: "post",
    body: params.body
  });
};

export const getLeadRenewal = () => {
  return request(`v1/sellers/customer-360/lead-renewal`);
};

export const postLeadRenewal = params => {
  return request(`v1/sellers/customer-360/lead-renewal/appeal`, {
    method: "post",
    body: params.body
  });
};

export const postEPayment = params => {
  return request(`v1/sellers/reservation/e-payment`, {
    method: "post",
    body: params
  });
};
